<script>
import Component from '~/sites/oknanebodvere/pages/page/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/stranka/:slug',
      de: '/seite/:slug',
      en: '/page/:slug',
      sk: '/stranka/:slug',
    },
  },
  head() {
    const slug = this.$route?.params?.slug

    if (slug !== 'nastaveni-cookies') {
      return {}
    }

    return {
      script: [
        {
          src: '//report.cookie-script.com/r/31f6c629d3964013408e807e54613140.js',
          charset: 'UTF-8',
          'data-cookiescriptreport': 'report',
        },
      ],
    }
  },
}
</script>
